import { Group, Stack } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { SegmentedControl, Select, TextInput } from "@tfg/ui"
import { useState } from "react"

import { ControlledTable } from "~/components/table/ControlledTable"

import { useMagicLinkColumns } from "./magicLink/columns"
import { useMagicLinkCount, useMagicLinkLogsQuery } from "./magicLink/hooks"
import { useRefreshTokenColumns } from "./refreshToken/columns"
import { filterOptions } from "./refreshToken/filter"
import {
  useRefreshTokenCount,
  useRefreshTokenLogsQuery,
} from "./refreshToken/hook"

export function SecurityAdmin() {
  const refreshTokenColumns = useRefreshTokenColumns()
  const magicLinkColumns = useMagicLinkColumns()
  const [pageState, setPageState] = useState<"refresh-token" | "magic-link">(
    "refresh-token"
  )
  const [filterValue, setFilterValue] = useState<string | null>(
    filterOptions[0].value
  )
  const [searchValue, setSearchValue] = useState<string>("")
  const [debouncedSearchValue] = useDebouncedValue<string>(searchValue, 600)

  return (
    <Stack>
      <Group>
        <SegmentedControl
          data={[
            { label: "Refresh Token", value: "refresh-token" },
            { label: "Magic Link", value: "magic-link" },
          ]}
          onChange={() => {
            if (pageState === "refresh-token") setPageState("magic-link")
            else setPageState("refresh-token")
          }}
        />
      </Group>

      {pageState === "refresh-token" ? (
        <>
          <Group>
            <Select
              w={250}
              size="xs"
              placeholder="Select a type of user"
              label="Type of user"
              value={filterValue}
              onChange={setFilterValue}
              data={filterOptions}
            />
            <TextInput
              w={250}
              size="xs"
              placeholder="Search by email"
              label="Email"
              value={searchValue}
              onChange={(event) => setSearchValue(event.currentTarget.value)}
            />
          </Group>
          <ControlledTable
            columns={refreshTokenColumns}
            countQuery={useRefreshTokenCount}
            defaultPageSize={20}
            defaultSorting={[{ id: "updatedAt", desc: true }]}
            query={useRefreshTokenLogsQuery}
            filterOption={filterValue}
            searchValue={debouncedSearchValue}
          />
        </>
      ) : (
        <ControlledTable
          columns={magicLinkColumns}
          countQuery={useMagicLinkCount}
          defaultPageSize={20}
          defaultSorting={[{ id: "updatedAt", desc: true }]}
          query={useMagicLinkLogsQuery}
          filterOption={null}
        />
      )}
    </Stack>
  )
}
